const getEnv = (key: string, defaultValue: any = undefined) => {
  try {
    return import.meta.env[key] !== undefined ? import.meta.env[key] : defaultValue;
  } catch (e) {
    return defaultValue;
  }
};

export const env = {
  appName: 'App React',
  environment: getEnv('MODE', 'development'),
  queryDebug: getEnv('VITE_QUERY_DEBUG', true),

  // Auth Method Configuration
  authMethod: getEnv('VITE_AUTH_METHOD', 'alurkerja_sso'),

  apiBaseUrl: getEnv('VITE_API_BASEURL', 'https://aosonline.merapi.alurkerja.com'),
  apiTasklistBaseUrl: getEnv('VITE_API_TASKLIST_BASEURL', 'https://tasklist2.minipc.javan.id'),
  cloudStorage: getEnv('VITE_MINIO_CLOUD', 'https://minio.merapi.javan.id'),
  micrositeUrl: getEnv('VITE_MICROSITE_URL', 'https://org.saas.merapi.alurkerja.com'),
  homePageUrl: getEnv('VITE_HOMEPAGE_URL', 'https://aosonline.merapi.alurkerja.com'),
  discTestUrl: getEnv('VITE_DISC_TEST_URL', 'https://erp.asaconsulting.id/psikotest'),
  minioBaseUrl:
    getEnv('VITE_MINIO_BASE_URL') || getEnv('VITE_API_TASKLIST_BASEURL') || 'https://tasklist2.minipc.javan.id',

  // Keycloak Configuration
  keycloakUrl: getEnv('VITE_KEYCLOAK_URL', 'https://keycloak.merapi.javan.id'),
  keycloakRealm: getEnv('VITE_KEYCLOAK_REALM', 'internal'),
  keycloakClientId: getEnv('VITE_KEYCLOAK_CLIENT_ID', 'joglo'),
  keycloakClientSecret: getEnv('VITE_KEYCLOAK_CLIENT_SECRET'),
  keycloakRedirectUri: getEnv('VITE_KEYCLOAK_REDIRECT_URI', 'http://localhost:3306/callback'),

  sentryDsn: getEnv('VITE_SENTRY_DSN'),

  // AlurKerja SSO Configuration
  AK_CLIENT_ID: getEnv('VITE_AK_CLIENT_ID', '3'),
  AK_CLIENT_SECRET: getEnv('VITE_AK_CLIENT_SECRET'),
  AK_REDIRECT_URI: getEnv('VITE_AK_REDIRECT_URI', 'http://localhost:3306/callback'),

  IS_SETTING_ENABLED: getEnv('VITE_PRODUCTION') === 'true' ? false : true,

  // Admin Roles Configuration
  ADMIN_ROLES: (function () {
    const roles = getEnv('VITE_ADMIN_ROLES');
    if (typeof roles === 'string' && roles.length > 0) {
      return roles.split(',');
    }
    return ['admin', 'owner', 'superadmin'];
  })(),
};
